import { TradingEntity } from 'api'
import { TradingEntityHelper } from 'model'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { authorisedUserSelector } from 'selectors/connectionSelectors'
import { tradingEntityGetterSelector } from 'selectors/tradingEntitySelectors'
import { Field } from 'view/components/inputs'
import { Selectbox, SelectboxProps } from 'view/components/options'

interface OwnerTradingEntitySelectboxProps
  extends Omit<SelectboxProps<TradingEntity, string>, 'optionKeys' | 'getOption' | 'getOptionText'> {}

export const OwnerTradingEntitySelectbox = (props: OwnerTradingEntitySelectboxProps) => {
  const user = useSelector(authorisedUserSelector)
  const getOption = useSelector(tradingEntityGetterSelector)

  const optionKeys = useMemo(() => user.tradingEntityDetails.map(d => d.tradingEntityId), [user.tradingEntityDetails])

  return <Selectbox {...props} optionKeys={optionKeys} getOption={getOption} getOptionText={TradingEntityHelper.getName} />
}

export const OwnerSelectboxField = Field(OwnerTradingEntitySelectbox)
